export const NOTIFICATION_ANCHOR = { vertical: "top", horizontal: "right" }
export const NOTIFICATION_AUTOHIDE_DURATION = 2000
export const REPORT_TYPE_ONLINE = "ONLINE"
export const REPORT_TYPE_CNC = "CNC"